/* Clarion Camping — glamping experience setups.
   Each card is a problem someone wants solved, not a pile of SKUs.
   "Add the setup" puts every ticked piece we actually stock into the cart in one request. */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function wire(card) {
    var btn = card.querySelector('[data-add-set]');
    if (!btn) return;
    var status = card.querySelector('[data-set-status]');
    var boxes = card.querySelectorAll('[data-buy]');
    var total = card.querySelector('[data-set-total]');

    function retotal() {
      var sum = 0, n = 0;
      Array.prototype.forEach.call(boxes, function (b) {
        if (b.checked) { sum += Number(b.getAttribute('data-price')) || 0; n++; }
      });
      if (total) total.textContent = n ? money(sum) + ' for ' + n + (n === 1 ? ' piece' : ' pieces') : 'Nothing ticked';
      btn.disabled = !n;
    }

    Array.prototype.forEach.call(boxes, function (b) { b.addEventListener('change', retotal); });
    retotal();

    btn.addEventListener('click', function () {
      var items = [];
      Array.prototype.forEach.call(boxes, function (b) {
        if (b.checked) items.push({ id: Number(b.getAttribute('data-buy')), quantity: Number(b.getAttribute('data-qty')) || 1 });
      });
      if (!items.length) return;
      btn.disabled = true;
      if (status) status.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        if (status) status.innerHTML = 'In your cart. <a href="/cart">Check out</a>.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        if (status) status.innerHTML = 'That did not go through. <a href="/collections/glamping">Add them from the collection</a>.';
      }).finally(function () { btn.disabled = false; });
    });
  }

  function boot() {
    var cards = document.querySelectorAll('[data-cc-exp]');
    for (var i = 0; i < cards.length; i++) wire(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
